<template>
    <div class="payment-methods">
        <label for="pm-select-ya"
               class="payment-method-ya"
               :class="{'checked-pm' : paymentType == paymentTypes.wallet}">
            <input type="radio" name="paymentType" id="pm-select-ya"
                   :value="paymentTypes.wallet"
                   v-model="paymentType">
        </label>
        <label for="pm-select-card"
               class="payment-method-card"
               :class="{'checked-pm' : paymentType == paymentTypes.card}">
            <input type="radio" name="paymentType" id="pm-select-card"
                   :value="paymentTypes.card"
                   v-model="paymentType">
        </label>
    </div>
</template>

<script>
    import constants from '@/constants';

    export default {
        name: "SelectPaymentMode",

        props: ['value'],

        data() {
            return {
                paymentType: null
            }
        },

        created() {
            if (!!this.value)
                this.paymentType = this.value;
        },

        computed: {
            paymentTypes() {
                return constants.yandexMoney.paymentTypes;
            },
        },

        watch: {
            value(val) {
                this.paymentType = val;
            },

            paymentType(val) {
                // Проброс значения наверх для v-model
                this.$emit('input', val);
            }
        }
    }
</script>